import {gql} from '@apollo/client'

// Buy a Twilio number and wire it up as the agent's personal Caller ID
// (attach to the SIP trunk + create the VICIdial AGENT DID). Post-purchase
// steps that fail come back in `warnings` without losing the number.
export const PURCHASE_PROVISIONED_NUMBER = gql`
  mutation PurchaseProvisionedNumber($phoneNumber: String!, $friendlyName: String) {
    purchaseProvisionedNumber(phoneNumber: $phoneNumber, friendlyName: $friendlyName) {
      success
      message
      warnings
      number {
        id
        e164
        areaCode
        status
        trunkAttached
        didCreated
      }
    }
  }
`

// Choose which of the agent's numbers is used as the outbound Caller ID.
export const SET_OUTBOUND_CID = gql`
  mutation SetOutboundCid($id: ID!) {
    setOutboundCid(id: $id) {
      success
      number {
        id
        isOutboundCid
      }
    }
  }
`

// Enable SMS on a provisioned number: create a Twilio SMS channel (inbound
// routing) + point the number's SMS webhook at it. Voice stays untouched.
export const ENABLE_SMS_ON_NUMBER = gql`
  mutation EnableSmsOnNumber($id: ID!) {
    enableSmsOnNumber(id: $id) {
      success
      message
      warnings
      number {
        id
        e164
        capabilities
      }
    }
  }
`

// Set a provisioned number as the DEFAULT sending line for a channel (SMS/WHATSAPP).
export const SET_DEFAULT_MESSAGING_NUMBER = gql`
  mutation SetDefaultMessagingNumber($id: ID!, $channelType: String!) {
    setDefaultMessagingNumber(id: $id, channelType: $channelType) {
      success
      number {
        id
        smsDefault
      }
    }
  }
`

// Release a provisioned number: remove its DID and delete it on Twilio.
export const RELEASE_PROVISIONED_NUMBER = gql`
  mutation ReleaseProvisionedNumber($id: ID!) {
    releaseProvisionedNumber(id: $id) {
      success
      message
      warnings
    }
  }
`

// (Re)assign a number's routing to a user or a group (round-robin member).
// Billing stays with the owner; this only changes inbound + outbound routing.
export const ASSIGN_PROVISIONED_NUMBER = gql`
  mutation AssignProvisionedNumber($numberId: ID!, $targetUserId: ID, $targetGroupId: ID) {
    assignProvisionedNumber(numberId: $numberId, targetUserId: $targetUserId, targetGroupId: $targetGroupId) {
      success
      message
      warnings
      number {
        id
        routeMode
        assignedUserId
        assignedUserName
        assignedGroupId
        assignedGroupName
      }
    }
  }
`
